import { useLocalization } from "@fluent/react";
import { Tooltip } from "@narmi/design_system";
import useClipboard from "cerulean/src/useClipboard";
import styles from "./CopyableText.module.css";

interface CopyableTextProps {
  text?: string;
  children?: React.ReactNode;
  className?: string;
}

const CopyableText = ({ text, children, className }: CopyableTextProps) => {
  const { l10n } = useLocalization();

  const { copy, status } = useClipboard(String(text ?? ""), {
    successMessage: l10n.getString("copied-clipboard-text-success", null, "Copied!"),
    pendingMessage: l10n.getString("copied-clipboard-text-pending", null, "Click to copy"),
    resetDelay: 2000,
  });

  return (
    <span
      role="button"
      className={`${styles.copyableText} sentry-mask${className ? ` ${className}` : ""}`}
      onClick={copy}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          void copy();
        }
      }}
    >
      <Tooltip text={status}>
        <span>{children ?? text}</span>
      </Tooltip>
    </span>
  );
};

export { CopyableText };
